import _ from 'lodash'

export default () => ({
    state: {
        taskStates: [],
    },
    getters: {
        taskStates: state => state.taskStates,
    },
    mutations: {
        setTaskStates: (state, taskStates) => {
            state.taskStates = taskStates
        },
    },
    actions: {
        async taskStatesLoad({ commit }) {
            // const data = await Axios.get('http://docker:5984/asd/task-state')
            // commit('setTaskTypes', data)
            // return DATA_TYPES.data
        },
        async saveTaskState({ commit }, data) {
            // const data = await Axios.post('http://docker:5984/asd/task-state')
            console.info(data)
            commit('setTaskStates', data)
        },
    },
})
